import { render, staticRenderFns } from "./ItemEditor.vue?vue&type=template&id=2df05c44&scoped=true&"
import script from "./ItemEditor.vue?vue&type=script&lang=js&"
export * from "./ItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./ItemEditor.vue?vue&type=style&index=0&id=2df05c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df05c44",
  null
  
)

export default component.exports